import React from 'react';

import SvgIcon, { IProps } from '../SvgIcon';

export default (props: IProps) => (
  <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M13.1719 12L8.22192 7.05002L9.63592 5.63602L15.9999 12L9.63592 18.364L8.22192 16.95L13.1719 12Z"/>
  </SvgIcon>
);